import { sendOneTimeCodeRequest } from '../../../services/registration/RegistrationService';
import { ROUTES } from '../../../../Routes';
import { logger } from '@origin-digital/reporting-client';
import { EMAIL_OR_PHONE } from 'ts/constants/UrlParams';
import { navigateToErrorPage } from '../../pages/error/ErrorNavigation';
import { ERROR_CODES } from '../../pages/error/ErrorCodes';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import { getRegisterBootstrapUrl } from 'ts/config/ConfigService';

const sendOtcAndRedirect = async (history: any, username: string) => {
  try {
    if (await sendOneTimeCodeRequest(username)) {
      return history.push({
        pathname: ROUTES.MANUAL_REG_ONE_TIME_CODE,
        search: `?${EMAIL_OR_PHONE}=${username}`,
      });
    }
    // otherwise no user with that username found
  } catch (e) {
    // something went wrong with otc request
  }
  logger.fail('could not send otc for manual reg');
  navigateToErrorPage(
    ERROR_CODES.MANUAL_REG_OTC_ERROR,
    ErrorFlow.manualReg,
    getRegisterBootstrapUrl(),
    history,
  );
};

export { sendOtcAndRedirect };
